export default [{
    path: '/messages',
    name: 'Notices',
    component: () => import( /* webpackChunkName: "notices-route" */ '../views/Notices/index.vue'),
    meta: {
        title: 'Notices'
    },
}]
